export const getHeaderCMSCodes = () => {
  const userdetails = localStorage.getItem("userdetail");
  const userFromLocalStorage = JSON.parse(userdetails);
  let codes = [];
  if (userFromLocalStorage.authorizationPolicy) {
    userFromLocalStorage.authorizationPolicy.forEach((a) => {
      switch (a) {
        case "general":
          codes.push("navigatingcorp");
          break;
        case "expo":
          codes.push("retailers");
          break;
        case "field":
          codes.push("field");
          break;
        case "corporate":
          codes.push("corporate");
          break;
      }
    })
  }
  return codes;
}

/**
 * Async version: also checks CMS access_code_mapping for reporting access.
 * Call this when you need to include CMS-driven reporting tab visibility.
 */
export const getHeaderCMSCodesWithMapping = async (getAccessCodeMappings, deliveryClient) => {
  const codes = getHeaderCMSCodes();
  const accessCode = (localStorage.getItem("accessCode") ?? "").toLowerCase();
  if (accessCode && !codes.includes("field")) {
    const mappings = await getAccessCodeMappings(deliveryClient);
    const config = mappings.get(accessCode);
    // If CMS mapping flags this access code for reporting, add "field" CMS code
    if (config?.hasReportingAccess) {
      codes.push("field");
    }
  }
  return codes;
}

export const addTotalRow = (columns, data) => {
  let dataToModify = JSON.parse(JSON.stringify(data));
  if (dataToModify && dataToModify.length > 0) {
    let colName = columns[0]["accessor"];
    let grandTotalRecord = dataToModify.find((gt)=>gt[colName].toLowerCase()=="zzz");
    grandTotalRecord.displayNonLink = true;
    grandTotalRecord[colName] = "Grand Total";
    return dataToModify;
  }
}